import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import {
  serializeWorkOrderAmendmentWrite,
} from '#/api/momMgmt/workOrder/amendment/serialize';

/**
 * POST `/mom/work-order/{workOrderId}/amendment`（僅 PROCESSING）。
 *
 * @param {string} workOrderId
 * @param {object} values
 */
export async function createWorkOrderAmendment(workOrderId, values) {
  const { data: raw } = await request.post(
    `/mom/work-order/${workOrderId}/amendment`,
    serializeWorkOrderAmendmentWrite(values),
  );
  return parseVer4DetailResponse(raw);
}
